
import { useForm } from "@inertiajs/inertia-vue3";
import { defineComponent, computed } from "vue";
import Multiselect from "../General/Multiselect.vue";
import Button from "../Buttons/Button.vue";
import axios from "axios";
import { useStore } from "@/stores/order";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";

export default defineComponent({
  setup() {
    const orderStore = useStore();

    const form = useForm({
      barcode: null,
      product_id: null as number | null,
      amount: 1,
    });

    const sendForm = () => {
      form.post(
        route(`orders.orderlines.store`, { order: orderStore.order_id }),
        {
          onSuccess: () => {
            form.reset();

            // @ts-ignore
            document.getElementById("addProductAmount")?.blur();

            const detailsElement = document.getElementById("orderDetails");
            console.log({ detailsElement });
            detailsElement?.scrollTo(0, detailsElement?.scrollHeight);
          },
          preserveScroll: true,
          preserveState: true,
        }
      );
    };

    const getProducts = async (query: string) => {
      return new Promise(async (resolve, reject) => {
        if (query.length <= 0) {
          return resolve([]);
        }
        try {
          const result = await axios.get(route("products.search"), {
            params: {
              query,
            },
          });

          resolve(result.data);
        } catch (error) {
          reject(error);
        }
      });
    };

    const orderIsEditable = computed(() => orderStore.isEditable);

    const focusAmount = (e: Event) => {
      if (e?.target) {
        return;
      }

      document.getElementById("addProductAmount")?.focus();
    };

    const selectText = (e: FocusEvent) => {
      if (e.target instanceof HTMLInputElement) {
        e?.target?.select();
      }
    };

    const clearAmount = () => {
      form.amount = 1;
    };

    return {
      form,
      sendForm,
      getProducts,
      focusAmount,
      selectText,
      clearAmount,
      orderIsEditable,
      loadingIcon: mdiLoading,
      actionsLocked: computed(() => orderStore.actionsLocked),
    };
  },
  components: { Multiselect, Button, SvgIcon },
});
